<template>
    <section :class="{ 'w-full': props.mobile }">
        <div v-if="!auth.isAuthenticated"
            :class="props.mobile ? 'flex flex-col gap-4 w-full pt-4' : 'flex items-center gap-2 border-l border-iron md:border-none pl-4'">
            <div :class="{ 'flex items-center gap-3 w-full': props.mobile }" @click="urlHandler.redirectAndScroll('/login')">
                <CircularButton :icon="'pi-sign-in'" :to="'/login'" />
                <span v-if="props.mobile" class="text-[#5d372b] font-medium text-sm">{{ translate('sign in / login', 'capitalize') }}</span>
            </div>

            <div :class="{ 'flex items-center gap-3 w-full': props.mobile }" @click="urlHandler.redirectAndScroll('/register')">
                <CircularButton :icon="'pi-user-plus'" :to="'/register'" />
                <span v-if="props.mobile" class="text-[#5d372b] font-medium text-sm">{{ translate('register', 'ucfirst') }}</span>
            </div>

            <div :class="{ 'flex items-center gap-3 w-full': props.mobile }" @click="context.openLanguageModal">
                <CircularButton :icon="'pi-language'" />
                <span v-if="props.mobile" class="text-[#5d372b] font-medium text-sm">{{ translate('language', 'ucfirst') }}</span>
            </div>
        </div>

        <div v-else :class="props.mobile ? 'w-full flex flex-col gap-2' : 'relative inline-block'"
            @mouseleave="!props.mobile && startClosePopup()" @mouseenter="!props.mobile && showPopup()">
            <div :class="props.mobile ? 'flex items-center gap-3 pb-3 border-b border-[#d8c2ab] w-full cursor-pointer' : ''">
                <CircularButton :type="'BORDER'" :textContent="auth.getUser?.getInitialsOfName() || 'UN'" />
                <div v-if="props.mobile" class="flex flex-col text-left">
                    <span class="text-base font-bold text-[#5d372b]">{{ auth.getUser?.name || 'User' }}</span>
                    <span class="text-xs text-[#b47b52]">{{ auth.getUser?.email || 'User' }}</span>
                </div>
            </div>

            <UserMenuDropdownComponent v-show="showUserOption" :isModal="!props.mobile" />
        </div>
    </section>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth';
import { ref, defineProps, watch, onMounted } from 'vue';
import { useContextStore } from '@/stores/context';
import CircularButton from '../misc/CircularButton.vue';
import UserMenuDropdownComponent from './UserMenuDropdownComponent.vue';
import urlHandler from '@/composables/urlHandler';
import { translate } from '@/composables/translate';

const props = defineProps({
    mobile: {
        type: Boolean,
        default: false,
    }
});

const auth = useAuthStore();
const context = useContextStore();
const showUserOption = ref(false);
let closeTimeout = null;

onMounted(() => {
    if (props.mobile) {
        showUserOption.value = true;
    }
})

watch(() => props.mobile, (isMobile) => {
    if (isMobile) {
        showUserOption.value = true;
    }
});

function showPopup() {
    clearTimeout(closeTimeout);
    showUserOption.value = true;
}

function startClosePopup() {
    closeTimeout = setTimeout(() => {
        showUserOption.value = false;
    }, 200);
}

// function toggleMobilePopup() {
//     showUserOption.value = !showUserOption.value;
// }
</script>